import React, { memo } from 'react';

import { AGILITY_BACKLOG } from '@atlassian/jira-common-constants/src/analytics-sources.tsx';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import { ForgeActionMenuItems as BaseForgeActionMenuItems } from '@atlassian/jira-forge-ui-action-apps/src/ui/action-menu/index.tsx';
import { BACKLOG_ACTION_MODULE } from '@atlassian/jira-forge-ui-constants/src/constants.tsx';
import { forgeBacklogModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import { useBacklogSelector } from '../../../../../state/index.tsx';
import { getBacklogExtensionData } from '../../../../../state/selectors/app/index.tsx';

const ForgeActionMenuItems = () => {
	const { loading, data: extensions } = useResource(forgeBacklogModuleResource);
	const extensionData = useBacklogSelector(getBacklogExtensionData);

	if (loading || !extensions || extensions.length === 0) {
		return null;
	}

	return (
		<BaseForgeActionMenuItems
			module={BACKLOG_ACTION_MODULE}
			analyticsSource={AGILITY_BACKLOG}
			testId="software-backlog.header.menu.content.forge-items"
			extensions={extensions}
			extensionData={extensionData}
		/>
	);
};

export const BacklogForgeActionMenuItems = memo(() => (
	<ErrorBoundary packageName="software" id="forge-items">
		<ForgeActionMenuItems />
	</ErrorBoundary>
));
